import {
  AppNavbarContainer,
  ExpandButtonContainer,
  MenuContainer,
} from "./styles";
import { useBreakpoint } from "@avenue-8/sidekick-ui";
import { ExpandSidebarButton } from "@shared/components/ExpandSidebarButton";
import { useUIStore } from "@store/ui.store";
import { AppLogo } from "../AppLogo";
import { HeaderMoreActions } from "./components/HeaderMoreActions";

export const AppNavbar = () => {
  const toggleSidebar = useUIStore((state) => state.toggleSidebar);
  const isSidebarOpen = useUIStore((state) => state.isSidebarOpen);
  const isSidebarOpenDesktop = useUIStore(
    (state) => state.isSidebarOpenDesktop,
  );

  const isLaptopDown = useBreakpoint("laptop");

  if (isLaptopDown) {
    return (
      <AppNavbarContainer>
        <ExpandButtonContainer>
          <ExpandSidebarButton
            onClick={() => toggleSidebar(true)}
            hide={isSidebarOpen}
          />
        </ExpandButtonContainer>
        <AppLogo size={{ sidekick: "xs", radar: "md" }} hide={isSidebarOpen} />
        <MenuContainer>
          <HeaderMoreActions />
        </MenuContainer>
      </AppNavbarContainer>
    );
  }

  return (
    <AppNavbarContainer>
      <AppLogo
        size={{ sidekick: "xs", radar: "md" }}
        hide={isSidebarOpenDesktop}
      />
      <MenuContainer>
        <HeaderMoreActions />
      </MenuContainer>
    </AppNavbarContainer>
  );
};
